/** 中文文案 */
export const ZH: Record<string, string> = {
  // ---- 通用
  'ui.confirm': '确定',
  'ui.cancel': '取消',
  'ui.close': '关闭',
  'ui.back': '返回',
  'ui.level': '等级',
  'ui.coins': '金币',
  'ui.food': '食物',
  'ui.energy': '能量',
  'ui.reputation': '声望',
  'ui.xp': '经验',
  'ui.owned': '已拥有',
  'ui.locked': '未解锁',
  'ui.lvRequire': '{lv} 级解锁',
  'ui.buy': '购买',
  'ui.sell': '出售',
  'ui.sellAll': '全部出售',
  'ui.claim': '领取',
  'ui.free': '免费',
  'ui.max': '已满级',
  'ui.new': '新!',

  // ---- 开始界面
  'start.title': '天堂小岛',
  'start.subtitle': 'Paradise Isle · 你的海上家园',
  'start.newGame': '开垦新岛',
  'start.continue': '继续游戏',
  'start.namePrompt': '给岛主起个名字',
  'start.defaultName': '小岛主',
  'start.slotEmpty': '空存档位',
  'start.delete': '删除',
  'start.deleteConfirm': '确定删除这个存档吗？此操作不可恢复！',
  'start.tagline': '种田 · 钓鱼 · 斗兽 · 装扮 · 串门',

  // ---- HUD 与底栏
  'hud.bag': '背包',
  'hud.shop': '商店',
  'hud.quests': '任务',
  'hud.collections': '图鉴',
  'hud.wardrobe': '换装',
  'hud.neighbors': '邻居',
  'hud.edit': '布置',
  'hud.settings': '设置',
  'hud.home': '回家',
  'hud.energyFull': '能量已满',
  'hud.nextEnergy': '{t}后+1',

  // ---- 动作菜单
  'act.till': '开垦 ({coins}金币)',
  'act.plant': '播种',
  'act.water': '浇水',
  'act.harvest': '收获',
  'act.clear': '铲除',
  'act.removePlot': '还原草地',
  'act.feed': '喂食',
  'act.collect': '收取',
  'act.fight': '战斗!',
  'act.fish': '钓鱼',
  'act.weed': '除草',
  'act.pet.feed': '喂食 (5食物)',
  'act.pet.play': '玩耍',
  'act.chase': '驱赶',
  'act.helpWater': '帮忙浇水',
  'act.prank': '捣蛋',

  // ---- 面板标题
  'panel.inventory': '背包',
  'panel.shop': '岛屿商店',
  'panel.quests': '任务日志',
  'panel.achievements': '成就',
  'panel.daily': '每日任务',
  'panel.tutorial': '岛主手册',
  'panel.collections': '收藏图鉴',
  'panel.fishdex': '鱼类图鉴',
  'panel.beastdex': '野兽图鉴',
  'panel.wardrobe': '梳妆台',
  'panel.neighbors': '左邻右舍',
  'panel.settings': '设置',
  'panel.offline': '离开期间…',

  // ---- 商店
  'shop.seeds': '种子',
  'shop.trees': '果树',
  'shop.animals': '动物',
  'shop.buildings': '建筑',
  'shop.clothing': '服装',
  'shop.pets': '宠物',
  'shop.tools': '工具',
  'shop.expand': '扩建岛屿',
  'shop.expandDesc': '扩大到 {size}×{size}（需 {lv} 级）',
  'shop.rod': '鱼竿升级',
  'shop.rodT1': '竹制鱼竿',
  'shop.rodT2': '玻纤鱼竿',
  'shop.rodT3': '碳素大师竿',
  'shop.rodDesc': '更好的鱼竿能钓到更稀有的鱼',
  'shop.grow': '生长 {t}',
  'shop.produce': '产出周期 {t}',
  'shop.feedCost': '每次喂食 {n} 食物',
  'shop.beauty': '美观 +{n}',
  'shop.adoptName': '给它起个名字吧：',

  // ---- 背包
  'inv.empty': '背包空空如也，去收获点什么吧！',
  'inv.sellFor': '单价 {n} 金币',

  // ---- 任务
  'quest.done': '已完成',
  'quest.progress': '进行中',
  'quest.reward': '奖励',
  'quest.dailyRefresh': '每日 0 点刷新',
  'quest.noneActive': '暂时没有进行中的任务',

  // ---- 图鉴
  'dex.caught': '已收集 {a}/{b}',
  'dex.unknown': '？？？',
  'dex.beastNote': '击败野兽解锁图鉴',

  // ---- 换装
  'wd.skin': '肤色',
  'wd.hair': '发型',
  'wd.face': '表情',
  'wd.top': '上装',
  'wd.bottom': '下装',
  'wd.hat': '帽子',
  'wd.accessory': '配饰',
  'wd.takeOff': '脱下',

  // ---- 邻居
  'nb.friendship': '好友度',
  'nb.visit': '去串门',
  'nb.hire': '雇佣 ({coins}金币)',
  'nb.hireDesc': '请TA来帮你浇水/除草/驱兽',
  'nb.helpLeft': '今日可帮工 {n} 次',
  'nb.prankLeft': '可捣蛋 {n} 次',
  'nb.friendCode': '好友码',
  'nb.myCode': '复制我的岛屿码',
  'nb.visitCode': '粘贴好友码参观',
  'nb.codeCopied': '岛屿码已复制，发给朋友吧！',
  'nb.codePrompt': '粘贴好友的岛屿码：',
  'nb.codeBad': '这个岛屿码无法识别…',
  'nb.visiting': '正在参观 {name} 的小岛',
  'nb.snapshotNote': '这是 {name} 分享时的岛屿快照',

  // ---- 钓鱼
  'fish.cast': '甩竿',
  'fish.wait': '等鱼上钩…',
  'fish.bite': '咬钩了！点击！',
  'fish.reel': '连点收线！保持在绿区！',
  'fish.escaped': '鱼跑掉了…',
  'fish.caught': '钓到了 {name}！',
  'fish.newRecord': '图鉴新收录！',

  // ---- 战斗
  'battle.title': '击退 {name}！',
  'battle.hint': '在指针滑到绿区时点击攻击！',
  'battle.hit': '命中!',
  'battle.crit': '暴击!!',
  'battle.miss': '落空… 野兽反击了！',
  'battle.win': '成功击退！获得 {coins} 金币',
  'battle.flee': '撤退',

  // ---- 设置
  'set.lang': '语言 Language',
  'set.sound': '音效',
  'set.music': '音乐',
  'set.export': '导出存档',
  'set.import': '导入存档',
  'set.exportDone': '存档已复制到剪贴板',
  'set.importPrompt': '粘贴存档数据：',
  'set.importBad': '存档数据无效',
  'set.importDone': '导入成功！',
  'set.reset': '回到标题',
  'set.about': '关于',

  // ---- 离线摘要
  'off.title': '欢迎回来，{name}！',
  'off.away': '你离开了 {t}',
  'off.crops': '{n} 块作物成熟了',
  'off.animals': '{n} 只动物的产出好了',
  'off.beasts': '{n} 只野兽入侵了小岛！',
  'off.weeds': '长出了 {n} 株杂草',
  'off.trampled': '{n} 株作物被野兽踩坏了…',
  'off.energy': '能量恢复了 {n} 点',
  'off.gift': '宠物给你带回了礼物：{name}',

  // ---- 教程提示
  'tut.hint': '当前任务',

  // ---- 消息（msg.*）
  'msg.noEnergy': '能量不足！休息一下或升级恢复',
  'msg.noCoins': '金币不够',
  'msg.noFood': '食物不够，去收获农作物吧',
  'msg.noSeed': '没有这种种子了，去商店买点',
  'msg.noSpace': '岛上没有空地了',
  'msg.needGrass': '只能在草地上开垦',
  'msg.occupied': '这里被占用了',
  'msg.weedHere': '先清掉杂草',
  'msg.noPlot': '这里没有农田',
  'msg.plotBusy': '这块田已经种上了',
  'msg.noCrop': '这块田是空的',
  'msg.noNeedWater': '现在不需要浇水',
  'msg.waterCd': '刚浇过水，歇一会儿',
  'msg.notReady': '还没准备好',
  'msg.notFound': '目标不存在',
  'msg.notHungry': '它现在不饿',
  'msg.locked': '等级不够，还未解锁',
  'msg.owned': '已经拥有了',
  'msg.notOwned': '还没有这件',
  'msg.cannotPlace': '不能放在这里',
  'msg.cannotSell': '这个不能出售',
  'msg.notEnough': '数量不够',
  'msg.maxRod': '鱼竿已是最高级',
  'msg.maxIsland': '小岛已经扩到最大啦',
  'msg.helpLimit': '今天在这家帮工次数用完了',
  'msg.prankLimit': '今天在这家捣蛋次数用完了',
  'msg.allClaimed': '奖励都领完了',
  'msg.cleared': '清理完成',
  'msg.animalBought': '新伙伴入住小岛！',
  'msg.rodUpgraded': '鱼竿升级成功！',
  'msg.questReady': '有任务可以交啦！',
  'msg.friendGift': '好友度提升！{name}送了你 {n} 金币',
  'msg.hireDone': '邻居帮你干了 {n} 件活',
  'msg.levelUp': '升到 {lv} 级！能量全满！',
  'msg.saved': '已保存',
  'msg.achievement': '达成成就：{name} {tier}星',
  'msg.beastArrive': '有野兽入侵小岛了！',
  'msg.petGift': '{pet} 带回了 {item}！',
  'msg.expanded': '小岛扩建成功！',
};
